//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useCallback } from 'react';
import { useContext } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { useParams } from 'react-router-dom';
// import SimpleBar from 'simplebar-react';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
import { LayoutContext } from '../common/contexts';
import { setClassNameInDefns } from '../common/definitionHelper';
import useSimpleBarRef from '../common/hooks/useSimpleBarRef';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';
import TopNav from '../topNav/TopNav';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
import SignUpSuccessful from './subComponents/SignUpSuccessful';
import EmailVerifiedSuccessful from './subComponents/EmailVerifiedSuccessful';
import Processing from './subComponents/Processing';
import ActionCodeFailed from './subComponents/ActionCodeFailed';
import PasswordResetSuccessful from './subComponents/PasswordResetSuccessful';
import EmployerAccountLinkage from './subComponents/EmployerAccountLinkage';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: {},
    pageContainer: { backgroundColor: '#FAFAFC', overflow: 'hidden', height: '100%', minHeight: '100%', flexWrap: 'unset' },
    pageHeader: { maxHeight: '81px' },
    pageContent: {
        flex: 1,
        overflow: 'hidden',
    },
    tempContainer: { alignItems: 'center' },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        // props,
    } = params;

    const defns = {
        pageContainer: { container: true, direction: 'column' },
        pageHeader: { item: true, lg: 12, md: 12, sm: 12, xs: 12 },
        pageContent: { item: true, container: true },
        tempContainer: { item: true, container: true, direction: 'column' },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
// A custom hook that builds on useLocation to parse the query string for you.
// const useQuery = () => {
//     const { search } = useLocation();

//     return React.useMemo(() => new URLSearchParams(search), [search]);
// };

const PAGE_ID_VERIFYING_EMAIL = 'verifying-email';
const PAGE_ID_EMAIL_VERIFIED_SUCCESSFUL = 'email-verify-successful';
const PAGE_ID_SIGN_UP_SUCCESSFUL = 'sign-up-successful';
const PAGE_ID_ACTION_CODE_FAILED_VERIFY_EMAIL = 'email-verify-fail';
const PAGE_ID_ACTION_CODE_FAILED_EMAIL_VERIFICATION = 'email-verify-action-code-fail';
const PAGE_ID_PASSWORD_RESET_SUCCESSFUL = 'password-reset-successful';
const PAGE_ID_ACTION_CODE_FAILED_RESET_PASSWORD = 'reset-password-fail';
const PAGE_ID_EMPLOYER_ACCOUNT_LINKAGE = 'emp-account-linkage';

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const TempAuthLayout = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    // const appContext = useContext(AppContext);
    const context = useContext(LayoutContext);
    // const { setLoadingDialogOpen } = context;
    const { simpleBarRef: pageContentSimpleBarEl, scrollToTop: scrollToPageTop } = useSimpleBarRef();
    console.log('this console log for avoiding ES lint error', pageContentSimpleBarEl);
    const { subPageId } = useParams();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { showVerificationEmailSent } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const getPageComponent = useCallback(() => {
        switch (subPageId) {
            case PAGE_ID_EMAIL_VERIFIED_SUCCESSFUL:
                return <EmailVerifiedSuccessful />;
            case PAGE_ID_SIGN_UP_SUCCESSFUL:
                return <SignUpSuccessful />;
            case PAGE_ID_VERIFYING_EMAIL:
                return <Processing />;
            case PAGE_ID_ACTION_CODE_FAILED_VERIFY_EMAIL:
                return <ActionCodeFailed emailVerificationFailed />;
            case PAGE_ID_ACTION_CODE_FAILED_EMAIL_VERIFICATION:
                return <ActionCodeFailed emailVerificationFailedInvalidCode />;
            case PAGE_ID_PASSWORD_RESET_SUCCESSFUL:
                return <PasswordResetSuccessful />;
            case PAGE_ID_ACTION_CODE_FAILED_RESET_PASSWORD:
                return <ActionCodeFailed resetPasswordFailed />;
            case PAGE_ID_EMPLOYER_ACCOUNT_LINKAGE:
                return <EmployerAccountLinkage />;
            default:
                return <EmailVerifiedSuccessful />;
        }
    }, [subPageId]);

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <LayoutContext.Provider value={{ ...context, scrollToPageTop }}>
            <Grid {...defns.pageContainer}>
                <Grid {...defns.pageHeader}>
                    <TopNav />
                </Grid>
                <Grid {...defns.pageContent}>
                    {/* <SimpleBar style={{ height: '100%', width: '100%', flex: 1 }} ref={pageContentSimpleBarEl}>
                        <Grid {...defns.tempContainer}>{getPageComponent()}</Grid>
                    </SimpleBar> */}
                    <Grid {...defns.tempContainer}>{getPageComponent()}</Grid>
                </Grid>
            </Grid>
        </LayoutContext.Provider>
    );
};

export default TempAuthLayout;
